import ArrowDown from "assets/icons/glory/chevronUp.svg?react";
import classNames from "classnames";
import "./styles.sass";

type LoyaltyButtonSliderProps = {
  disabled: boolean;
  handleClick: () => void;
  revert?: boolean;
  className?: string;
};

export const LoyaltyButtonSlider = ({
  disabled,
  handleClick,
  revert = false,
  className,
}: LoyaltyButtonSliderProps) => {
  const classNameButton = classNames(
    "LoyaltyButtonSlider",
    className,
    disabled && "LoyaltyButtonSlider_disabled",
  );
  const classNameIcon = classNames(
    "LoyaltyButtonSlider__icon",
    revert && "LoyaltyButtonSlider__icon_revert",
    disabled && "LoyaltyButtonSlider__icon_disabled",
  );

  return (
    <button
      type="button"
      className={classNameButton}
      onClick={handleClick}
      disabled={disabled}
    >
      <ArrowDown className={classNameIcon} />
    </button>
  );
};
